// -----------------------------------------
// -------- GENERATED FROM .FX FILE --------
// -----------------------------------------
// Source: src/babylon/shaders/outline_id_map_generation.vertex.fx
import { ShaderStore } from '@inter-ikea-betrakta-babylonjs/core/Engines/shaderStore.js';
const name = 'outline_id_map_generationVertexShader';
const shader = `attribute vec3 position;
#include<bonesDeclaration>
#include<morphTargetsVertexGlobalDeclaration>
#include<morphTargetsVertexDeclaration>[0..maxSimultaneousMorphTargets]
#include<instancesDeclaration>
uniform mat4 viewProjection;
varying vec4 vPosition;
#ifdef INSTANCES
attribute vec4 outline_instance_data;
varying vec4 vOutlineColor;
#endif
void main(void)
{
vec3 positionUpdated = position;
#include<morphTargetsVertex>[0..maxSimultaneousMorphTargets]
#include<instancesVertex>
#include<bonesVertex>
#ifdef CUBEMAP
vPosition = finalWorld * vec4(positionUpdated, 1.0);
gl_Position = viewProjection * finalWorld * vec4(position, 1.0);
#else
vPosition = viewProjection * finalWorld * vec4(positionUpdated, 1.0);
gl_Position = vPosition;
#endif
#ifdef INSTANCES
vOutlineColor = outline_instance_data;
#endif
}`;
// Sideeffect
ShaderStore.ShadersStore[name] = shader;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const outline_id_map_generationVertexShader = { name, shader };
//# sourceMappingURL=outline_id_map_generation.vertex.js.map